var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-preview"},[_c('div',{staticClass:"block-content",style:(_vm.contentStyle),attrs:{"inert":_vm.inert}},[_c('cms-block-renderer',{attrs:{"block":_vm.previewBlock,"editable":false,"current-language":_vm.currentLanguage,"index":0}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }